'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$UpdateUPCP(username, password, pin, base64Cert) {
  this.a0X = null;
  this.a0V = null;
  this.a0W = null;
  this.a0U = null;
  this.a0X = username;
  this.a0V = password;
  this.a0W = pin;
  this.a0U = base64Cert;
}
export { $c_Lpresto_types$proto$UpdateUPCP as $c_Lpresto_types$proto$UpdateUPCP };
$p = $c_Lpresto_types$proto$UpdateUPCP.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$UpdateUPCP;
/** @constructor */
function $h_Lpresto_types$proto$UpdateUPCP() {
}
export { $h_Lpresto_types$proto$UpdateUPCP as $h_Lpresto_types$proto$UpdateUPCP };
$h_Lpresto_types$proto$UpdateUPCP.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$proto$UpdateUPCP)) {
    if ((this.a0X === x$0.a0X)) {
      var x = this.a0V;
      var x$2 = x$0.a0V;
      var $x_2 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.a0W;
      var x$4 = x$0.a0W;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.a0U;
      var x$6 = x$0.a0U;
      return ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 4;
});
$p.s = (function() {
  return "UpdateUPCP";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.a0X;
      break;
    }
    case 1: {
      return this.a0V;
      break;
    }
    case 2: {
      return this.a0W;
      break;
    }
    case 3: {
      return this.a0U;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_types$proto$UpdateUPCP(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mi)));
}
export { $isArrayOf_Lpresto_types$proto$UpdateUPCP as $isArrayOf_Lpresto_types$proto$UpdateUPCP };
var $d_Lpresto_types$proto$UpdateUPCP = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$UpdateUPCP, "presto.types$proto$UpdateUPCP", ({
  mi: 1,
  bx: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$UpdateUPCP as $d_Lpresto_types$proto$UpdateUPCP };
//# sourceMappingURL=presto.types$proto$-Update-U-P-C-P.js.map
